import { Grid, Tab, Tabs, styled } from "@mui/material";
import { useEffect, useState } from "react";

import { GetMarketLoggedInForm } from "store/api/market";
import http from "config/http";
import useNotify from "hooks/useNotify";

function MarketTabs({ value, onChange }) {
  const [dataDest, setDataDest] = useState();
  const notify = useNotify();

  const getMarketLoggedInForm = async () => {
    try {
      const { data } = await http.get(GetMarketLoggedInForm);
      setDataDest(data?.data?.lisCoinDestination);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getMarketLoggedInForm();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container my={2}>
      <Grid item xs={12} textAlign="center">
        <TabsStyle
          value={value}
          onChange={onChange}
          aria-label="secondary tabs example"
        >
          {dataDest?.map((data) => (
            <Tab value={data.id} label={data.name} />
          ))}
        </TabsStyle>
      </Grid>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    maxWidth: "50%",
    margin: "auto",
  },

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default MarketTabs;
